import type { AllPlanPrices } from '../../SignInManager'

type PaddlePlanPrice = AllPlanPrices['monthly']

export interface PlanOptionDetail {
  price?: string
  priceAmount?: number
  id?: string
  canFreeTrial: boolean
  trialDays: number
}

export interface PlanTierDetail {
  currencyCode?: string
  countryCode?: string
  month: PlanOptionDetail
  year: PlanOptionDetail
}

export function hasPlanPrices(detail: PlanTierDetail): boolean {
  return [detail.month, detail.year].every(
    option => Boolean(option.id?.trim()) && Number.isFinite(option.priceAmount) && option.priceAmount >= 1
  )
}

function toPlanOption(plan: PaddlePlanPrice): PlanOptionDetail {
  return {
    price: plan.recurring.price.gross,
    priceAmount: plan.recurring.price.amount,
    id: plan.plan_id,
    canFreeTrial: plan.recurring.subscription.trial_days > 0,
    trialDays: plan.recurring.subscription.trial_days,
  }
}

/**
 * Maps a monthly/yearly pair from `SignInManager.getPlanPrices()` into the
 * `planDetail` shape the plan panel renders. Shared by the paywall modal and
 * the partner landing page so both show identical Paddle-localized prices.
 */
export function toPlanDetail(monthly: PaddlePlanPrice, yearly: PaddlePlanPrice): PlanTierDetail {
  return {
    // Currency / country are the same for both plans (driven by the customer's
    // location). Prefer yearly, then monthly, so derived prices in
    // MetsiKonChoosePlan format like Paddle's headline.
    currencyCode: yearly?.recurring?.currencyCode ?? monthly?.recurring?.currencyCode,
    countryCode: yearly?.recurring?.countryCode ?? monthly?.recurring?.countryCode,
    month: toPlanOption(monthly),
    year: toPlanOption(yearly),
  }
}
